import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import PaperDetailContent from '@/components/PaperDetailContent';
import { loadPapers, loadConfig, getPaperById, getRelatedPapers, removeUserPaper } from '@/lib/data';

export default function PaperDetailPage() {
  const { '*': id } = useParams();
  const navigate = useNavigate();
  const [papers, setPapers] = useState(null);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    Promise.all([loadPapers(), loadConfig()]).then(([p, c]) => {
      setPapers(p);
      setConfig(c);
    });
  }, []);

  if (!papers || !config) {
    return (
      <div className="main-layout">
        <div className="loading">
          <div className="loading__spinner" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  const paper = getPaperById(papers, id);

  if (!paper) {
    return (
      <div className="main-layout">
        <Header config={config} />
        <main className="main-content">
          <div className="empty-state">
            <h3>Paper not found</h3>
            <button className="btn btn--primary" onClick={() => navigate('/')}>Back to Papers</button>
          </div>
        </main>
      </div>
    );
  }

  const artifactConfig = Object.fromEntries((config.typesOfArtifact || []).map((t) => [t.id, t]));
  const relatedPapers = getRelatedPapers(papers, paper);

  const handleRemove = async () => {
    await removeUserPaper(paper._userKey);
    navigate('/');
  };

  return (
    <div className="main-layout">
      <Header config={config} />
      <main className="main-content">
        <button className="btn btn--ghost paper-detail__back" onClick={() => navigate('/')}>← Back to Papers</button>
        <PaperDetailContent
          paper={paper}
          artifactConfig={artifactConfig}
          relatedPapers={relatedPapers}
          onRelatedClick={(relatedId) => navigate(`/papers/${relatedId}`)}
          onRemove={paper._userAdded ? handleRemove : undefined}
        />
      </main>
    </div>
  );
}
